/**
 * Analytics Query Hook
 * Fetches time-series + available voltage combos for the Status temporal plot.
 *
 * Spatial frames are NOT part of this response: the Status page fetches the
 * displayed snapshot on demand via useLatestSnapshotQuery (/latest?at=).
 */

import { useQuery } from '@tanstack/react-query';
import { measurementsService } from 'src/api/services';
import { queryKeys } from './queryKeys';

export interface AnalyticsResponse {
  available_combos: string[];
  timeseries: Record<string, { timestamps: string[]; values: number[] }>;
}

export function useAnalyticsDataQuery(
  installationId: string | null,
  voltageCombo: string | null,
  limit: number = 50
) {
  return useQuery<AnalyticsResponse | null>({
    queryKey: queryKeys.measurements.analytics(installationId || '', voltageCombo),
    queryFn: async () => {
      if (!installationId) return null;
      return await measurementsService.getAnalytics(installationId, voltageCombo, limit);
    },
    enabled: !!installationId,
    staleTime: 5 * 60 * 1000,
  });
}
